<div class="youtube-modal">
  <h1 class="youtube-modal__title">{{ data.title }}</h1>
  <div class="youtube-modal__content">
    <ng-container
      *ngIf="youTubeApiScriptAdded$ | async; else youtubeVideoError"
    >
      <ng-container *ngIf="hasNoError$ | async; else youtubeVideoError">
        <youtube-player
          (error)="onError()"
          [playerVars]="data.playerVars"
          [videoId]="data.videoId"
        ></youtube-player
      ></ng-container>
    </ng-container>
  </div>
  <div class="youtube-modal__actions">
    <div class="youtube-modal__actions__button">
      <ui-button
        (handleClick)="closeModal($event)"
        [isSecondary]="true"
        buttonClassName="button-full-width"
        buttonId="youtube-modal-close"
        buttonText="Close"
        gtmTag="youtube-modal-close"
      ></ui-button>
    </div>
  </div>
</div>

<ng-template #youtubeVideoError>
  There's been an issue with the YouTube video, sorry about that!
</ng-template>
